import { Landmark, Building2, GraduationCap, MapPin, CalendarDays, ExternalLink, Briefcase, BookOpen } from "lucide-react";
import { experience } from "@/data/profile";

const icons = { Landmark, Building2, GraduationCap, Briefcase, BookOpen };

export const Experience = () => (
  <section className="section section-alt" id="experience">
    <div className="container">
      <p className="eyebrow">02 · Experience</p>
      <h2 className="section-title">Where I've made an impact</h2>
      <div className="timeline" data-testid="experience-timeline">
        {experience.map((exp) => {
          const Icon = icons[exp.icon];
          return (
            <article className="timeline-item" key={exp.id} data-testid={exp.testId}>
              <div className="timeline-marker">
                <Icon size={18} />
              </div>
              <div className="timeline-card">
                <div className="timeline-head">
                  <div>
                    <h3 className="timeline-role">{exp.role}</h3>
                    <p className="timeline-company">{exp.company}</p>
                  </div>
                  <span className="period-badge">
                    <CalendarDays size={12} /> {exp.period}
                  </span>
                </div>
                <p className="timeline-meta">
                  <MapPin size={12} /> {exp.location} · {exp.type}
                </p>
                <p className="body-text">{exp.description}</p>
                {exp.link && (
                  <a
                    href={exp.link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-link"
                    data-testid={`experience-link-${exp.id}`}
                  >
                    <ExternalLink size={13} /> {exp.link.label}
                  </a>
                )}
                <div className="chip-row">
                  {exp.skills.map((s) => (
                    <span className="chip" key={s}>{s}</span>
                  ))}
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  </section>
);
